import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import BackerkitBanner from "@/components/BackerkitBanner";
import Philosophy from "@/components/Philosophy";
import GamesShowcase from "@/components/GamesShowcase";
import StoreTeaser from "@/components/StoreTeaser";
import Newsletter from "@/components/Newsletter";
import Footer from "@/components/Footer";
import CentralThread from "@/components/CentralThread";

export default function Landing() {
  return (
    <div
      data-testid="landing-page"
      className="grain relative min-h-screen bg-[#0A0908] text-[#F2EFEB]"
    >
      <CentralThread />
      <Header />

      <main className="relative z-10">
        <Hero />
        <BackerkitBanner />
        <Philosophy />
        <GamesShowcase />
        <StoreTeaser />
        <Newsletter />
      </main>

      <Footer />
    </div>
  );
}
